import { usePortfolio, usePortfolios } from "@/api/hooks/portfolio";
import { WindowKind, instanceId, useDesktop } from "@/overlay/components/window";
import { useCallback, useEffect, useRef } from "react";

/** Refresh shared queries after Manager changes without replacing the consumer's selection or draft. */
export function usePortfolioSelection(portfolioId: string, enabled = true) {
  const desktop = useDesktop();
  const library = usePortfolios(enabled);
  const detail = usePortfolio(enabled ? portfolioId || undefined : undefined);
  const managerVisible = desktop.isWindowVisible(instanceId(WindowKind.PortfolioManagerWindow));
  const wasVisible = useRef(managerVisible);
  const { refetch: refreshList } = library;
  const { refetch: refreshDetail } = detail;
  const refresh = useCallback(() => {
    if (!enabled) {
      return;
    }
    void refreshList({ cancelRefetch: false });
    if (portfolioId) {
      void refreshDetail({ cancelRefetch: false });
    }
  }, [enabled, portfolioId, refreshDetail, refreshList]);
  useEffect(() => {
    if (wasVisible.current && !managerVisible) {
      refresh();
    }
    wasVisible.current = managerVisible;
  }, [managerVisible, refresh]);
  return { library, detail, managerVisible, refresh };
}
